module.exports = __webpack_public_path__ + "static/media/71.9b58ff65.png";